export const contentTypeOptions = [
    { value: "text", label: "ESCRIBE TU NEÓN" },
    { value: "image", label: "SUBIR TU SVG PERSONALIZADO" },
  ];

export const NEON_COLORS = [
    {
      value: '#ffffff',
      label: 'Blanco Neón',
      glow: ['#ffffff33', '#ffffffaa', '#ffffff'],
    },
    {
      value: '#ff3333',
      label: 'Rojo Neón',
      glow: ['#ff000033', '#ff0000aa', '#ff0000'],
    },
    {
      value: '#33ff33',
      label: 'Verde Neón',
      glow: ['#00ff0033', '#00ff00aa', '#00ff00'],
    },
    {
      value: '#3333ff',
      label: 'Azul Neón',
      glow: ['#0000ff33', '#0000ffaa', '#0000ff'],
    },
    {
      value: '#ff33ff',
      label: 'Rosa Neón',
      glow: ['#ff00ff33', '#ff00ffaa', '#ff00ff'],
    },
    {
      value: '#ffff33',
      label: 'Amarillo Neón',
      glow: ['#ffff0033', '#ffff00aa', '#ffff00'],
    },
    {
      value: '#33ffff',
      label: 'Cian Neón',
      glow: ['#00ffff33', '#00ffffaa', '#00ffff'],
    },
    {
      value: '#ff9933',
      label: 'Naranja Neón',
      glow: ['#ff990033', '#ff9900aa', '#ff9900'],
    },
    {
      value: '#ff66cc',
      label: 'Magenta Neón',
      glow: ['#ff66cc33', '#ff66ccaa', '#ff66cc'],
    },
    {
      value: '#66ff66',
      label: 'Lima Neón',
      glow: ['#66ff6633', '#66ff66aa', '#66ff66'],
    },
    {
        value: '#f5deb3',
        label: 'Beige Neón',
        glow: ['#f5deb333', '#f5deb3aa', '#f5deb3'],
      },
  ];
  
  
 export const NEON_FONTS = [
    {
      value: "Pattaya",
      label: "Pattaya",
      url: 'https://fonts.googleapis.com/css2?family=Freehand&family=Imperial+Script&family=League+Script&family=New+Amsterdam&family=Pattaya&display=swap'
    },
    {
      value: "Pirata One",
      label: "Pirata One",
      url: 'https://fonts.googleapis.com/css2?family=Freehand&family=Imperial+Script&family=League+Script&family=Neonderthaw&family=New+Amsterdam&family=Pattaya&family=Pirata+One&display=swap'
    },
    {
      value: "Imperial Script",
      label: "Imperial Script",
      url: 'https://fonts.googleapis.com/css2?family=Freehand&family=Imperial+Script&family=New+Amsterdam&display=swap'
    },
    {
      value: "League Script",
      label: "League Script",
      url: 'https://fonts.googleapis.com/css2?family=Freehand&family=Imperial+Script&family=League+Script&family=New+Amsterdam&display=swap'
    },
    {
      value: "Freehand",
      label: "Freehand",
      url: 'https://fonts.googleapis.com/css2?family=Freehand&family=Imperial+Script&family=League+Script&family=New+Amsterdam&display=swap'
    },
    {
      value: "Neonderthaw",
      label: "Neonderthaw",
      url: 'https://fonts.googleapis.com/css2?family=Freehand&family=Imperial+Script&family=League+Script&family=Neonderthaw&family=New+Amsterdam&family=Pattaya&display=swap'
    },
  ];
  
  
export const cutOptions = [
    { value: "option1", label: "RECTANGULAR", price: 10 },
    { value: "option2", label: "RECTANGULAR CON BORDES", price: 12 },
    { value: "option3", label: "CIRCULAR", price: 15 },
    { value: "option4", label: "SILUETA", price: 20 }
  ];

export const suportOptions = [
    { value: "option1", label: "SIN SOPORTE", price: 0 },
    { value: "option2", label: "CON TORNILLOS", price: 5 },
    { value: "option3", label: "COLGADO", price: 7 },
    { value: "option4", label: "CON PATAS", price: 10 }
  ];

export const useOptions = [
    { value: "option1", label: "INTERIOR", price: 5 },
    { value: "option2", label: "EXTERIOR (PROTECCIÓN)", price: 8 }
  ];

// Precios globales
export const TEXT_PRICE = 5; // Precio por cada texto
export const IMAGE_PRICE = 10; // Precio por cada imagen
export const SIZE_PRICE_PER_CM = 1; // Precio por cada cm de ancho y alto

export const calculateTotalPrice = (cut, support, use, textCount, width, height, contentType, uploadedImages) => {
    const cutPrice = cutOptions.find(option => option.value === cut)?.price || 0;
    const supportPrice = suportOptions.find(option => option.value === support)?.price || 0;
    const usePrice = useOptions.find(option => option.value === use)?.price || 0;
    const textPrice = contentType === 'text' ? textCount * TEXT_PRICE : 0; 
    const imagePrice = contentType === 'image' && uploadedImages.length > 0 ? IMAGE_PRICE : 0;
    const sizePrice = (parseInt(width, 10) || 0) * SIZE_PRICE_PER_CM + (parseInt(height, 10) || 0) * SIZE_PRICE_PER_CM;
    return cutPrice + supportPrice + usePrice + textPrice + imagePrice + sizePrice;
};

export const defaultBackgroundImages = [
  { src: 'https://www.lovemybar.es/wp-content/uploads/2025/03/fondoNeones6-scaled.jpeg', label: 'Fondo 4' },
  { src: 'https://www.lovemybar.es/wp-content/uploads/2025/03/fondoNeones3-scaled.jpeg', label: 'Fondo 1' },
  { src: 'https://www.lovemybar.es/wp-content/uploads/2025/03/fondoNeones4-scaled.jpeg', label: 'Fondo 2' },
  { src: 'https://www.lovemybar.es/wp-content/uploads/2025/03/fondoNeones5.jpg', label: 'Fondo 3' },
  { src: 'https://www.lovemybar.es/wp-content/uploads/2025/03/fondoNeones7-scaled.jpeg', label: 'Fondo 5' },
  { src: 'https://www.lovemybar.es/wp-content/uploads/2025/03/fondoNeones8-scaled.jpeg', label: 'Fondo 6' },
  { src: 'https://www.lovemybar.es/wp-content/uploads/2025/03/fondoNeones1-scaled.jpeg', label: 'Fondo 7' },
  { src: 'https://www.lovemybar.es/wp-content/uploads/2025/03/fondoNeones2.jpg', label: 'Fondo 8' },
  
];

export const CANVAS_WIDTH = 600;
export const CANVAS_HEIGHT = 800;
  
export  const FONT_SIZES = [20, 24, 26, 30, 36, 40, 46, 50, 60, 70, 74, 80, 86, 90, 100, 104];
